import axios from 'axios';

const BACKEND_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.tomuniversal.ru'
    : 'http://localhost:1337';

const webClient = axios.create({
  baseURL: BACKEND_BASE_URL,
});

export function orderCard(cardParams) {
  return webClient.post('messages', cardParams);
}

export function getDigitalDriverCards() {
  return webClient.get('digital-driver-cards');
}

export function buildUrl(url) {
  return BACKEND_BASE_URL + url;
}
